import { type AssetNetwork } from "@cpg/common";
import { HashLink } from "@/components/hash-link";

// Address (truncated, monospace, explorer link + copy button) on top, Vault
// ID as a quiet caption line underneath — one cell instead of two separate
// Address/Vault ID columns. Shared by the global Ledger list and the
// merchant detail page's Ledger and Deposit wallets tabs.

export interface AddressWithVaultProps {
  address: string | null;
  vaultId: string | null;
  network: AssetNetwork;
}

export function AddressWithVault({ address, vaultId, network }: AddressWithVaultProps) {
  return (
    <div className="space-y-0.5">
      <HashLink value={address} type="address" network={network} />
      <div className="text-xs text-muted-foreground">
        Vault <span className="font-mono">{vaultId ?? "—"}</span>
      </div>
    </div>
  );
}
